// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1BO0L","footer":"ModalError_footer__1ycxN"};